import { RUBRIC } from "@/data/rubric";

interface RubricProps {
  variant?: "full" | "summary";
}

export default function Rubric({ variant = "full" }: RubricProps) {
  if (variant === "summary") {
    return (
      <ol className="mt-6 space-y-2 font-sans text-small text-ink/90">
        {RUBRIC.map((c) => (
          <li key={c.number} className="flex gap-4">
            <span className="w-6 shrink-0 text-charcoal/50">
              {String(c.number).padStart(2, "0")}
            </span>
            <span>
              <span className="font-medium text-ink">{c.name}</span>
              <span className="text-charcoal/70"> — {c.oneLiner}</span>
            </span>
          </li>
        ))}
      </ol>
    );
  }

  return (
    <div className="mt-8 space-y-12">
      {RUBRIC.map((c) => (
        <section key={c.number} className="border-t border-rule pt-6">
          <div className="eyebrow mb-2">Dimension {String(c.number).padStart(2, "0")}</div>
          <h3 className="font-serif text-h3 text-ink">{c.name}</h3>
          <p className="mt-2 italic text-ink/80">{c.oneLiner}</p>
          <p className="mt-4 text-ink">{c.detail}</p>
          <div className="mt-6 grid gap-4 md:grid-cols-2">
            <div>
              <div className="eyebrow mb-1">Strong signal</div>
              <p className="text-small text-ink/90">{c.strongSignal}</p>
            </div>
            <div>
              <div className="eyebrow mb-1">Weak signal</div>
              <p className="text-small text-ink/90">{c.weakSignal}</p>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
